import { globalBreak } from "@/styles/break"
import { SxProps } from "@mui/material"

export const sidebarAppBarContainerSXP:SxProps = {
    bgcolor:'navbar.primary', 
    color:'#000'
}

export const sidebarAppBarContentSXP:SxProps = {
    color:'#000'
}

export const sidebarAccordionSummarySXP:SxProps = {
    bgcolor: globalBreak({mobile:'navbar.primary',desktop:'inherit'}),
	color: '#000',
}